export enum UserSettingName {
  FeedbackSubscriptionNotifications = "FeedbackSubscriptionNotifications",
  FeedbackStateNotifications = "FeedbackStateNotifications",
  CommentNotifications = "CommentNotifications",
  CommentPingNotifications = "CommentPingNotifications"
}
